import { render, staticRenderFns } from "./index.vue?vue&type=template&id=00c8fa7c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=00c8fa7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c8fa7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00c8fa7c')) {
      api.createRecord('00c8fa7c', component.options)
    } else {
      api.reload('00c8fa7c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=00c8fa7c&scoped=true&", function () {
      api.rerender('00c8fa7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/hotword-search/index.vue"
export default component.exports